<template>
    <div class="ah-page debug-tool-page">
        <div class="page-header">
            <div class="ah-container">Log Tool</div>
        </div>
        <div>
            <div style="display: flex; align-items: center; gap: 5px; padding: 10px;">
                <el-date-picker
                    v-model="dateRange"
                    ref="logTable"
                    value-format="timestamp"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="開始日期"
                    end-placeholder="結束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    size="small"
                >
                </el-date-picker>
                <el-select v-model="queryParams.staff_sno" size="small" placeholder="Staff" clearable filterable style="width: 150px;">
                    <el-option v-for="staff in staffList" :key="staff.sno" :value="staff.sno" :label="`${ staff.nam } (${ staff.sno })`"></el-option>
                </el-select>
                <el-input v-model="queryParams.url" size="small" placeholder="API Keyword" clearable filterable style="max-width: 300px;" @keyup.enter.native="refetchList" />
                <div>
                    <span style="font-size: 10pt;">頁數：</span>
                    <el-input v-model="queryParams.PageNum" size="small" style="width: 60px" @keyup.enter.native="refetchList" />
                </div>
                <div>
                    <span style="font-size: 10pt;">筆數：</span>
                    <el-input v-model="queryParams.PageSize" size="small" style="width: 60px" @keyup.enter.native="refetchList" />
                </div>
                <el-button size="small" type="primary" icon="el-icon-search" @click="refetchList">Search</el-button>
            </div>
            <div class="split-layout">
                <div style="position: relative;">
                    <div v-if="Array.isArray(logList)" style="position: absolute; top: 8px; right: 18px; z-index: 2; font-size: 10pt;">(共 {{ logList.length }} 筆)</div>
                    <el-table
                        :data="logList"
                        :height="tableHeight"
                        style="width: 100%"
                        size="small"
                        class="row-click log-list-table"
                        v-loading="loadingList"
                        :row-class-name="tableRowClassName"
                        @row-click="handleLogListRowClick"
                    >
                        <el-table-column prop="id" label="ID" width="85"></el-table-column>
                        <el-table-column prop="dat" label="時間" width="120" >
                            <template slot-scope="scope">{{ scope.row.dat | dateFormater("YYYY-MM-dd hh:mm") }}</template>
                        </el-table-column>
                        <el-table-column prop="staff_sno" label="使用者" width="110">
                            <template slot-scope="scope">
                                <div class="clickableTxt" @click="handleStaffClick(scope.row.staff_sno)">{{ scope.row.staff_nam }} ({{ scope.row.staff_sno }})</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status_code" label="狀態" width="50">
                            <template slot-scope="scope">
                                <div v-if="scope.row.status_code === 200" style="color: #13ce66">{{ scope.row.status_code }}</div>
                                <div v-if="scope.row.status_code !== 200" style="color: red">{{ scope.row.status_code }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="url" label="URL">
                            <template slot-scope="scope">
                                <div>{{ scope.row.url }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="data-panel">
                    <div class="view-tab">
                        <el-input v-model="logDataId" size="mini" style="width: 100px; margin-right: 5px" placeholder="Log ID" @keyup.enter.native="handleDataIdEnter" :disabled="loadingData" />
                        <div class="tab-item" :class="{ active: dataViewTab === 'raw' }" @click="dataViewTab = 'raw'">Raw Log</div>
                        <div class="tab-item" :class="{ active: dataViewTab === 'payload'}" @click="dataViewTab = 'payload'">Payload</div>
                    </div>
                    <div class="data-view">
                        <vue-json-pretty v-if=" dataViewTab === 'payload'" :data="payloadData" showIcon />
                        <vue-json-pretty v-if=" dataViewTab === 'raw'" :data="logData" showIcon />
                    </div>
                    <div class="hint-bar">{{ this.activeDate }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import moment from 'moment';

export default {
    components: {
        VueJsonPretty,
    },
    data() {
        return {
            dateRange: [null, null],
            staffList: [],
            queryParams: {
                ip: null,
                staff_sno: null,
                url: null,
                PageSize: 100,
                PageNum: 1,
            },
            logList: [],
            logData: null,
            logDataId: null,
            payloadData: null,
            tableHeight: 300,
            loadingList: false,
            loadingData: false,
            dataViewTab: 'payload', // raw | payload
            activeDate: null,
        };
    },
    async mounted() {
        this.resizeTableLayout();
        setTimeout(() => { this.resizeTableLayout(); }, 50);
        window.addEventListener('resize', this.resizeTableLayout);
        document.addEventListener('selectionchange', this.selectionChange);

        this.dateRange = [moment().startOf('day').format('x'), moment().endOf('day').format('x')];

        this.staffList = await this.fetchStaffList();
        this.logList = await this.fetchLogList();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeTableLayout);
        document.removeEventListener('selectionchange', this.selectionChange);
    },
    methods: {
        async fetchStaffList() {
            const resp = await this.$api({
                url: '/StaffManagementPage/GetStaffList',
                method: 'GET',
                params: {
                    PageSize: 999,
                    PageNum: 1,
                    TYP: 1,
                    ONF: 1,
                },
            });

            if (resp && resp.data && resp.data.staffs) {
                return resp.data.staffs;
            }
            return [];
        },
        async fetchLogList() {
            this.loadingList = true;
            try {
                const resp = await this.$api({
                    url: '/Tool/GetApiLogList',
                    method: 'GET',
                    params: {
                        startDate: this.dateRange[0],
                        endDate: this.dateRange[1],
                        ...this.queryParams,
                    },
                });
                return resp.data.items;
            } catch (ex) {
                console.error(ex);
                return [];
            } finally {
                this.loadingList = false;
            }
        },
        async fetchLogData(id) {
            this.loadingData = true;
            try {
                const resp = await this.$api({
                    url: '/Tool/GetApiLogData',
                    method: 'GET',
                    params: {
                        ID: id,
                    },
                });
                return resp.data.item;
            } catch (ex) {
                console.error(ex);
                return null;
            } finally {
                this.loadingData = false;
            }
        },
        async handleLogListRowClick(row, column) {
            this.logDataId = row.id;

            if (row.url.startsWith('GET ')) {
                this.logData = row;
                this.dataViewTab = 'raw';
            } else {
                this.logData = await this.fetchLogData(this.logDataId);
                this.payloadData = null;
                if (this.logData && this.logData.payload) {
                    this.payloadData = JSON.parse(this.logData.payload);
                }
            }
        },
        async refetchList() {
            this.logList = await this.fetchLogList();
        },
        async handleDataIdEnter() {
            this.logData = await this.fetchLogData(this.logDataId);
        },
        tableRowClassName({ row }) {
            if (row.status_code !== 200) {
                return 'error-row';
            }
            return 'success-row';
        },
        handleStaffClick(staffSno) {
            this.queryParams.staff_sno = staffSno;
        },
        resizeTableLayout() {
            const pageHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const tableY = this.$refs.logTable.$el.getBoundingClientRect().top;
            const tableHeight = pageHeight - tableY - 45;
            this.tableHeight = tableHeight;
        },
        selectionChange() {
            const selection = window.getSelection();
            const selectedText = selection.toString();
            if (selectedText && selectedText.length === 13) {
                const timestring = parseInt(selectedText, 10);
                this.activeDate = moment(timestring).format('YYYY-MM-DD HH:mm:ss');
                console.log('this.activeDate', this.activeDate);
            } else {
                this.activeDate = null;
            }
        },
        isDateString(text) {
            return !Number.isNaN(new Date(text));
        },
    },
};

</script>
<style lang="scss">
.ah-page.debug-tool-page {
    padding-bottom: 0;

    .clickableTxt {
        color: darkblue;
        cursor: pointer;

        &:hover {
            color: blue;
        }
    }

    .split-layout {
        display: grid;
        grid-template-columns: 1fr 1fr;
        height: calc(100dvh - 100px - 24px - 53px);
        .data-panel  {
            position: relative;
            display: grid;
            height: calc(100dvh - 100px - 24px - 53px);
            grid-template-columns: 1fr;
            grid-template-rows: 30px auto 30px;
            background-color: #fff;
            font-size: 10pt;
            border: 1px solid #ddd;
            .data-view {
                padding: 10px 0 40px 0;
                border-top: 1px solid #eee;
                overflow: auto;
            }
            .hint-bar {
                position: relative;
                bottom: 0;
                left: 0;
                height: 30px;
                width: 100%;
                background-color: #eee;
                font-size: 9pt;
                line-height: 30px;
                color: green;
                padding: 0 20px;
            }
        }
    }

    .view-tab {
        display: flex;
        align-items: center;
        height: 30px;
        background-color: #f6f6f6;
        padding: 0 2px;

        >.tab-item {
            color: #666;
            height: 30px;
            line-height: 30px;
            padding: 0 13px;
            border-bottom: 3px solid transparent;
            cursor: default;
            font-size: 9pt;

            &:hover {
                background-color: #eee;
            }

            &.active {
                color: darkblue;
                border-bottom: 3px solid darkblue;
            }
        }
    }

    .log-list-table {
        .error-row {
            background-color: #f9ebeb;

            &:hover td {
                background-color: #f9dfdf;
            }
        }
        .success-row {
            // background-color: #f0f9eb;

            // &:hover td {
            //     background-color: #e1f6d7;
            // }
        }
    }
}
</style>
